import { authFetch } from "./authApi.js";

async function unwrapApiResult(result) {
    /*
     * Dein authFetch gibt in vielen RaceVision-Dateien wahrscheinlich schon JSON zurück.
     * Falls es doch ein natives fetch Response-Objekt ist, behandeln wir das hier ebenfalls.
     */

    if (!result) {
        return null;
    }

    const looksLikeResponse =
        typeof result === "object" &&
        typeof result.text === "function" &&
        typeof result.ok === "boolean";

    if (!looksLikeResponse) {
        return result;
    }

    const text = await result.text();

    let data = null;
    try {
        data = text ? JSON.parse(text) : null;
    } catch {
        data = text;
    }

    if (!result.ok) {
        const detail =
            data?.detail ||
            data?.message ||
            (typeof data === "string" ? data : "") ||
            `HTTP ${result.status}`;

        throw new Error(detail);
    }

    return data;
}

export async function fetchRekoKnowledgeCategories({ seriesKey = "gt3x" } = {}) {
    const params = new URLSearchParams();

    if (seriesKey) {
        params.set("series_key", seriesKey);
    }

    const suffix = params.toString() ? `?${params.toString()}` : "";
    const result = await authFetch(`/api/reko/knowledge/categories${suffix}`);

    return unwrapApiResult(result);
}

export async function fetchRekoKnowledgeEntries({
                                                    categorySlug = "",
                                                    categoryId = "",
                                                    q = "",
                                                    decisionType = "",
                                                    seriesKey = "gt3x",
                                                } = {}) {
    const params = new URLSearchParams();

    if (categorySlug) {
        params.set("category_slug", categorySlug);
    }

    if (categoryId) {
        params.set("category_id", categoryId);
    }

    if (q) {
        params.set("q", q);
    }

    if (decisionType) {
        params.set("decision_type", decisionType);
    }

    if (seriesKey) {
        params.set("series_key", seriesKey);
    }

    const suffix = params.toString() ? `?${params.toString()}` : "";
    const result = await authFetch(`/api/reko/knowledge/entries${suffix}`);

    return unwrapApiResult(result);
}

export async function createRekoKnowledgeEntry(payload) {
    const result = await authFetch("/api/reko/knowledge/entries", {
        method: "POST",
        body: JSON.stringify(payload),
    });

    return unwrapApiResult(result);
}

export async function updateRekoKnowledgeEntry(id, payload) {
    const result = await authFetch(`/api/reko/knowledge/entries/${id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });

    return unwrapApiResult(result);
}

export async function deleteRekoKnowledgeEntry(id) {
    const result = await authFetch(`/api/reko/knowledge/entries/${id}`, {
        method: "DELETE",
    });

    return unwrapApiResult(result);
}